import { doc } from 'firebase/firestore';
import React from 'react'
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";
import { Icon } from "@iconify/react";
import copyIcon from "@iconify/icons-ic/content-copy";
import toast from 'react-hot-toast';
const DonationSuccessPageStep2HE = () => {

    const donateQuoteRef = doc(useFirestore(), "app/donate-page-quote");
    const {status, data} = useFirestoreDocDataOnce(donateQuoteRef);

    if(status == "loading") {
        return <div>Please wait...</div>;
    }

    const quote = data.quote || ""
    const quoteSource = data.quoteSource || "";
    const quoteHE = data.quoteHE || ""
    const quoteSourceHE = data.quoteSourceHE || "";
    

    const shareThisPage = async () => {
        // const input = document.createElement("input")
        // input.value = "https://r24.page.link/donate-link-he"
        
        // input.select();
        // input.setSelectionRange(0, 99999);

        // await navigator.clipboard.writeText(input.value);
        
        // toast.success("Link Copied!");

        // const canShare = navigator.canShare({
        //     url: "https://r24app.web.app/donate-he"
        // })

        // if(canShare) {
        //     await navigator.share({
        //         url: "https://r24app.web.app/donate-he"
        //     });
        // }

        try {
            window?.flutter_inappwebview?.callHandler('handlerShareHE')
              ?.then(function(result) {
                // print to the console the data coming
                // from the Flutter side.
                // console.log(JSON.stringify(result));
            });
          } catch (error) {
            console.log(error);
          }

        const canShare = navigator.canShare({
            url: "https://r24.page.link/donate-link-he"
        })

        if(canShare) {
            await navigator.share({
                url: "https://r24.page.link/donate-link-he"
            });
        } else {
            try {
                window?.flutter_inappwebview?.callHandler('handlerShareHE')
                  ?.then(function(result) {
                    // print to the console the data coming
                    // from the Flutter side.
                    // console.log(JSON.stringify(result));
                });
              } catch (error) {
                console.log(error);
              }
        }
    }

    return (
        <div
            dir='rtl'
            className="w-full bg-blue-50 h-screen"
            style={{
                backgroundImage: "url('/assets/donate_page/donate_page_bg.webp')",
            }}
        >
            <div className="w-11/12 sm:mt-0 mx-auto shadow-2xl md:w-1/2 rounded-3xl bg-white px-8 py-6 flex flex-col items-center justify-center">

                <div className='relative w-full'>
                    <p className='text-center font-bold'>מדברי הרבי:</p>
                    <img src="/assets/donate_page/quote.png" alt="quote" className='absolute top-0 right-0 h-8' />

                    <div className="mt-4">
                        <img src="/assets/donate_page/photo.png" alt="photo" className='w-32 h-32 block float-right p-2' />

                        <p className=''>
                        {quoteHE}
                        </p>
                    </div>

                    <div className="flex mt-4 gap-2">
                        <img src="/assets/donate_page/quote.png" alt="quote" className='block h-6' />
                        <p className='text-sm text-gray-500'>{quoteSourceHE}</p>
                    </div>
                </div>

                <div className='mt-6'>
                    <img
                        src="/assets/donate_page/donate_page_logo.jpg"
                        alt="logo"
                        className="w-32 h-32 object-contain"
                    />
                </div>

                <p className='mt-4 text-2xl text-center'>תודה רבה על תמיכתך!</p>

                <div>
                    <img src="/assets/donate_page/sign.png" alt="sign" className='h-16 object-contain mt-4' />
                </div>

                <p className="text-center mt-4">
                הרב שניאור לידר<br/>
                ישיבת תומכי תמימים בית שמש (ישראל)
                </p>

                <button onClick={shareThisPage} className="mt-6 bg-sky-100 hover:bg-sky-200 text-sky-600 px-8 py-3 rounded-full">
                שתף את הדף
                </button>
            </div>
        </div>
    )
}

export default DonationSuccessPageStep2HE